import React from 'react';
import { ReactComponent } from 'Common/components/Icons/person-remove.svg';

const PersonRemove = () => <ReactComponent className="MuiSvgIcon-root" />;

export default PersonRemove;
